module.exports = __webpack_public_path__ + "8b1e073d8163c1a2d58c91262e03d8a9.svg";